(function () {
  'use strict';

  if (!window.PICKIE_OPEN_CART_DRAWER) window.PICKIE_OPEN_CART_DRAWER = function () {
    var cartDrawer = window.cart;

    if (cartDrawer && typeof cartDrawer.openCartDrawer === 'function') {
      if (cartDrawer.cart === null) {
        cartDrawer.openCartDrawer();
      } else {
        if (typeof cartDrawer.getCart === 'function') cartDrawer.getCart();
        if (!cartDrawer.cartDrawerIsOpen) cartDrawer.openCartDrawer();
      }
      return;
    }

    var cartToggle = document.querySelector('[data-cart-toggle]');
    if (cartToggle) cartToggle.click();
  };

  function addUpsell(button) {
    var variantId = Number(button.getAttribute('data-variant-id'));
    if (!variantId || button.disabled) return;

    var originalText = button.textContent;
    var root = window.theme && window.theme.routes ? window.theme.routes.root : '/';

    button.disabled = true;
    button.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data && data.description ? data.description : 'Unable to add this item.');
          }
          return data;
        });
      })
      .then(function () {
        button.textContent = 'Added ✓';
        window.PICKIE_OPEN_CART_DRAWER();
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, 1200);
      })
      .catch(function (error) {
        button.disabled = false;
        button.textContent = originalText;
        window.alert(error.message || 'Unable to add this item.');
      });
  }

  document.addEventListener('click', function (event) {
    var upsellButton = event.target.closest('[data-pickie-cart-upsell]');

    if (upsellButton) {
      event.preventDefault();
      addUpsell(upsellButton);
      return;
    }

    if (event.target.classList && event.target.classList.contains('cart-drawer')) {
      if (window.cart && typeof window.cart.closeCartDrawer === 'function') {
        window.cart.closeCartDrawer();
      }
    }
  });
})();
